(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nav-mobile"] && !Shopify.designMode) return;
  try {
    const cartIconMobile = document.querySelector('#cart-icon-mobile');
  cartIconMobile.addEventListener('click', (e) => {
    e.preventDefault();
    document.querySelector('cart-icon').click();
  });

  document.addEventListener('DOMContentLoaded', () => {
  const originalBubble = document.querySelector('.cart-bubble__text-count'); // Replace with your original bubble selector
  const customBubble = document.querySelector('.nav__cart-count');     // Replace with your custom bubble selector

  if (!originalBubble || !customBubble) return;

  const observer = new MutationObserver((mutations) => {
    // Copy the text content (or count) whenever the original updates
    customBubble.textContent = originalBubble.textContent;
    
    // Optional: Toggle visibility if the cart is empty vs not empty
    customBubble.classList.toggle('is-empty', originalBubble.textContent.trim() === '0' || !originalBubble.textContent.trim());
  });

  // Watch for text changes and child element re-renders
  observer.observe(originalBubble, {
    childList: true,
    characterData: true,
    subtree: true
  });
});
  } catch(e) { console.error(e); }
})();

})();
